export const columnsCsv = [
  { label: "Date", key: "createdDate" },
  { label: "Name", key: "fullName" },
  { key: "sender", label: "Sender" },
  { key: "beneficiaryName", label: "Beneficiary" },
  { key: "receiver", label: "Receiver" },
  { label: "Sent(AED) ", key: "send" },
  { key: "status", label: "Status" },
  { key: "c3REF", label: "C3 Ref" },
];

export const options = [
  { value: "SUCCESSFUL", label: "Success" },

  { value: "FAILED", label: "Failed" },
  { value: "PENDING", label: "pending" }
];
export const options1 = [
  { value: "usa", label: "USA" },
  { value: "india", label: "India" },
];
